import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { trackSubscriptionCanceled } from '../../utils/analytics';

export default function SubscriptionCanceled() {
  const navigate = useNavigate();

  useEffect(() => {
    trackSubscriptionCanceled();
    navigate('/settings/subscription?checkout=canceled', { replace: true });
  }, []);

  return null;
}
